import isObject from 'lodash/isObject'

import type { TypeCallToActionWithoutUnresolvableLinksResponse } from '~/types/contentful'

export default function parseCtaDataLayer(
  cta: TypeCallToActionWithoutUnresolvableLinksResponse,
) {
  // see if dataLayer exists, if not, return empty object
  let dataLayer = {}
  if (!cta?.fields?.dataLayer)
    return {
      err: 'No dataLayer found ' + cta?.fields?.identifier,
    }

  if (!isObject(cta?.fields?.dataLayer))
    return {
      err: 'DataLayer is not an object for ' + cta?.fields?.identifier,
    }

  dataLayer = cta?.fields?.dataLayer || {}

  if (!('event' in dataLayer))
    return {
      err: 'dataLayer is missing required key "event"',
    }

  // let's check if it has the required key/value "event": "ga4.trackEvent"
  if (dataLayer.event !== 'ga4.trackEvent')
    return {
      err:
        'dataLayer is missing required key/value "event": "ga4.trackEvent" ' +
        cta?.fields?.identifier,
    }

  // at this point, we can assume we have a valid dataLayer object
  // but we need to do some string manipulation to get the data we need
  // so let's stringify it
  const stringified = JSON.stringify(cta?.fields?.dataLayer)

  // see if the stringified has {{linkUrl}} in it, if so, replace it with cta.link
  const dataLayerStringWithHref = stringified.replace(
    /{{linkUrl}}/g,
    cta?.fields?.link || '',
  )

  // see if dataLayerStringWithHref has {{linkText}} in it, if so, replace it with the cta.label
  const dataLayerStringWithHrefAndText = dataLayerStringWithHref.replace(
    /{{linkText}}/g,
    cta?.fields?.label || '',
  )

  // see if dataLayerStringWithHrefAndText has {{entryTitle}} in it, if so, replace it with the cta.entryTitle
  const dataLayerStringWithHrefAndTextAndEntryTitle =
    dataLayerStringWithHrefAndText.replace(
      /{{entryTitle}}/g,
      cta?.fields?.entryTitle || '',
    )

  // now we can parse the stringified object
  const parsedDataLayer = JSON.parse(
    dataLayerStringWithHrefAndTextAndEntryTitle,
  )

  // return the parsed dataLayer
  return {
    err: null,
    dataLayer: parsedDataLayer,
  }
}
